<div class="main-content product-dashboard">
  <div *ngIf="currentView === 'dashboard'">
    <div class="stats-section mb-4">
      <div class="stat-card border" *ngFor="let stat of stats">
        <div class="stat-icon">
          <i class="bi bi-{{stat.icon}}"></i>
        </div>
        <div class="stat-content">
          <h3>{{stat.value}}</h3>
          <p>{{stat.title}}</p>
        </div>
      </div>
    </div>
    <div class="row g-4">
      <div class="col-lg-8">
        <div class="card border-danger shadow mb-4">
          <div class="card-header bg-danger text-white">
            <h5 class="mb-0">Trending Products</h5>
            <a href="#" class="text-white">View All</a>
          </div>
          <div class="card-body">
            <div *ngIf="featuredProduct && featuredProduct.length > 0; else noProducts">
              <div class="list-group">
                <div *ngFor="let product of featuredProduct" class="list-group-item">
                  <div class="product-item d-flex align-items-center">
                    <div class="product-image bg-light rounded-circle p-3 me-3">
                      <i class="bi bi-phone text-danger fs-4"></i>
                    </div>
                    <div class="product-info flex-grow-1">
                      <h6 class="mb-1 fw-bold">{{product.title}}</h6>
                      <p class="mb-0 text-muted">{{product.description}}</p>
                    </div>
                    <div class="d-flex flex-column justify-content-center align-items-center">
                      <div class="product-price fw-bold text-danger">₹{{product.mop}}</div>
                      <div class="product-commission bg-danger text-white rounded-pill px-3 py-1 ms-2">
                        {{product.brand}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noProducts>
              <p class="text-center text-muted">No featured products available.</p>
            </ng-template>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
